import BaseService from '../core/BaseService';

export default class ClientsService extends BaseService {
  static async getClients(
    query: string,
    archived: string,
    module: string,
    page: number,
    pageSize: number
  ) {
    return await super.request(
      `/clients?q=${
        query ? encodeURIComponent(query) : ''
      }&archived=${archived}&mod=${module}&limit=${pageSize}&skip=${
        pageSize * (page - 1)
      }`
    );
  }

  static async getClientDetails(clientSlug: string) {
    return await super.request(`/clients/${clientSlug}`);
  }

  static async getOrganizationalUnits(clientSlug: string) {
    return await super.request(`/clients/${clientSlug}/organizational-units`);
  }

  static async updateClient(clientSlug: string, data: any) {
    return await super.request(`/clients/${clientSlug}`, 'PUT', data);
  }

  static async createClient(data: any) {
    return await super.request(`/clients`, 'POST', data);
  }

  static async archiveClient(clientSlug: string, archive: boolean) {
    return await super.request(
      `/clients/${clientSlug}/${archive ? 'archive' : 'unarchive'}`,
      'PUT'
    );
  }

  static async deleteClient(clientSlug: string) {
    return await super.request(`/clients/${clientSlug}`, 'DELETE');
  }
}
